<template>
  <SoPageWithHeader
    is-search-page
    dark-header-bg-color
    title="tariff quoter"
    meta-description="Use this tool to create a quote"
  >
    <template #header>
      <TariffQuoterSearch />
    </template>
    <template v-if="tariffQuoter.showResults">
      <TariffQuoterMeterpointsWidget v-if="!tariffQuoter.isGSPSearch" />
      <TariffQuoterFuelsWidget v-else />
      <TariffQuoterUsageWidget />
      <SoContainer v-if="tariffQuoter.isLoading" class="d-flex gap-2">
        <SoSkeleton v-for="n in 3" :key="n" class="w-33" type="image" />
      </SoContainer>
      <template
        v-else-if="
          tariffQuoter.selectedFuels.length &&
          tariffQuoter.tariffBundlesForGsp.length
        "
      >
        <TariffQuoterTariffSelector />
        <TariffQuoterCostSummary />
        <TariffQuoterComparisonTable />
      </template>
    </template>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useTariffQuoter } from "@/stores/tariffQuoter"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import TariffQuoterSearch from "./components/TariffQuoterSearch.vue"
  import TariffQuoterMeterpointsWidget from "./widgets/TariffQuoterMeterpointsWidget.vue"
  import TariffQuoterFuelsWidget from "./widgets/TariffQuoterFuelsWidget.vue"
  import TariffQuoterUsageWidget from "./widgets/TariffQuoterUsageWidget.vue"
  import TariffQuoterTariffSelector from "./widgets/TariffQuoterTariffSelector.vue"
  import TariffQuoterCostSummary from "./widgets/TariffQuoterCostSummary.vue"
  import TariffQuoterComparisonTable from "./widgets/TariffQuoterComparisonTable.vue"
  import SoContainer from "@/components/SoContainer.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"

  export default defineComponent({
    components: {
      SoPageWithHeader,
      TariffQuoterSearch,
      TariffQuoterMeterpointsWidget,
      TariffQuoterFuelsWidget,
      TariffQuoterUsageWidget,
      TariffQuoterTariffSelector,
      TariffQuoterCostSummary,
      TariffQuoterComparisonTable,
      SoContainer,
      SoSkeleton,
    },
    data() {
      return {
        tariffQuoter: useTariffQuoter(),
      }
    },
    computed: {
      selectedFuels() {
        return this.tariffQuoter.selectedFuels
      },
    },
    watch: {
      selectedFuels() {
        this.tariffQuoter.setMeterpointFuelUsage()
        this.tariffQuoter.setSelectedTariffs()
      },
    },
  })
</script>
